export enum MenuListType {
    AdminType =1 ,
    UserType = 2,
   
}